import { AgentsSecretsHost } from 'types'
import { AutoCompleteProps } from 'types/FormTypes'

interface FormValuesTypes {
  projectConfiguration: string
  username: string
  account: string
  etlAgent: AutoCompleteProps
  matillionHostedAgentId: string
  secretReferenceId: string
}

export const createGetWarehouseComputeResourceMutationData = ({
  projectConfiguration,
  username,
  etlAgent,
  matillionHostedAgentId,
  account,
  secretReferenceId
}: FormValuesTypes) => {
  return {
    agentId:
      projectConfiguration === AgentsSecretsHost.MatillionHosted
        ? matillionHostedAgentId
        : etlAgent.id,
    username: username.trim(),
    account: account.trim(),
    secretReferenceId: secretReferenceId
  }
}
